import Vue from 'vue'

import api from '../api'

export default {
  state: {
    commits: {
      1: {}
    },
    projects: []
  },
  getters: {
    getCommitsForProject(state) {
      return project => state.commits[project].project.commits
    },
    projects(state) {
      return state.projects
    }
  },
  mutations: {
    setCommitData(state, { project, commitData }) {
      Vue.set(state.commits, project, commitData)
      state.projects = commitData.projects
    },
    setCommitRelease(state, { commits, commit, release }) {
      const unreleased = commits.find(other => other.id === commit)

      unreleased.release = release
    }
  },
  actions: {
    async fetchCommits({ commit }, { project }) {
      const response = await api.get(`commits/${project}`)
      const commitData = response.data

      commit('setCommitData', { project, commitData })
    },
  }
}